module.exports = __webpack_public_path__ + "static/media/YB5F14_5.c75f231b.jpg";